import { VpCategories } from '@ps/bridge/qc/vp/categories'
import { VpMaskMethods } from '@ps/bridge/qc/vp/mask'

export default {
  maskAction: {
    [VpMaskMethods.vpEnableMaskComponent]: {
      label: '启用/禁用遮罩组件',
      category: VpCategories.mask,
      paramFormConfig: {
        isEnable: {
          title: '启用/禁用',
          field: {
            options: [
              {
                label: '启用',
              },
              {
                label: '禁用',
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpEnableMaskGroupComponent]: {
      label: '启用/禁用遮罩组',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: '启用/禁用',
          component: 'select',
          field: {
            options: [
              {
                label: '启用',
                value: true,
              },
              {
                label: '禁用',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpShowMaskGroup]: {
      label: '显示/隐藏遮罩组',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
          component: 'select',
          field: {
            options: [],
          },
        },
        isShow: {
          title: '显示/隐藏',
          component: 'select',
          field: {
            options: [
              {
                label: '显示',
                value: true,
              },
              {
                label: '隐藏',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpShowMaskSubGroup]: {
      label: '显示/隐藏遮罩分组',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
          component: 'select',
          field: {
            options: [],
          },
        },
        isShow: {
          title: '显示/隐藏',
          component: 'select',
          field: {
            options: [
              {
                label: '显示',
                value: true,
              },
              {
                label: '隐藏',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpEnableMaskShape]: {
      label: '启用/禁用遮罩效果',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: '启用/禁用',
          component: 'select',
          field: {
            options: [
              {
                label: '启用',
                value: true,
              },
              {
                label: '禁用',
                value: false,
              },
            ],
          },
        },
      },
    },
  },
}
